const prefix = process.env.VUE_APP_API_URL + 'statistic/'

export const getTypingSingleBasicLesson16StatisticDataAPI = prefix + 'getTypingSingleBasicLesson16StatisticData'
export const getTypingEssayStatisticDataAPI = prefix + 'getTypingEssayStatisticData'

export const getStatisticGlossariesAPI = prefix + 'getStatisticGlossaries'
export const getMinSelectableDateAPI = prefix + 'getMinSelectableDate'
export const getGlossaryPeriodStatisticDataAPI = prefix + 'getGlossaryPeriodStatisticData'
export const getGlossaryStatisticDataAPI = prefix + 'getGlossaryStatisticData'
export const getExamStatisticDataAPI = prefix + 'getExamStatisticData'

export const getLast7DaysTypingStatisticDataAPI = prefix + 'getLast7DaysTypingStatisticData'
export const getLast7DaysVocabularyStatisticDataAPI = prefix + 'getLast7DaysVocabularyStatisticData'
